class QaTabs extends HTMLElement {
  connectedCallback() {
    this.handleAccordionClick = this.handleAccordionClick.bind(this);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.setup(), { once: true });
    } else {
      this.setup();
    }
  }

  disconnectedCallback() {
    document.removeEventListener('click', this.handleAccordionClick, true);
  }

  setup() {
    this.initTabs();
    document.addEventListener('click', this.handleAccordionClick, true);
  }

  initTabs() {
    const sections = Array.from(document.querySelectorAll('.questions-and-answers'));
    if (sections.length < 2) return;

    const tablist = document.createElement('div');
    tablist.className = 'qa-tabs';
    tablist.setAttribute('role', 'tablist');
    tablist.setAttribute('aria-orientation', 'horizontal');
    const pageTitle = document.querySelector('.main-page-title');
    if (pageTitle && pageTitle.textContent.trim()) {
      tablist.setAttribute('aria-label', `${pageTitle.textContent.trim()} categories`);
    }

    const tabs = [];
    const wrappers = sections.map((s) => s.closest('.shopify-section') || s);

    sections.forEach((section, i) => {
      const titleEl = section.querySelector('.questions-and-answers__title');
      const label = titleEl ? titleEl.textContent.trim() : `Section ${i + 1}`;

      const tabId = `qa-tab-${i}`;
      const panelId = `qa-panel-${i}`;

      section.id = panelId;
      section.setAttribute('role', 'tabpanel');
      section.setAttribute('aria-labelledby', tabId);
      wrappers[i].hidden = i !== 0;

      if (titleEl) titleEl.hidden = true;

      const tab = document.createElement('button');
      tab.type = 'button';
      tab.id = tabId;
      tab.className = 'qa-tabs__tab heading-m-uppercase';
      tab.setAttribute('role', 'tab');
      tab.setAttribute('aria-selected', i === 0 ? 'true' : 'false');
      tab.setAttribute('aria-controls', panelId);
      tab.tabIndex = i === 0 ? 0 : -1;
      tab.textContent = label;

      tab.addEventListener('click', () => activate(i, true));
      tab.addEventListener('keydown', onKeydown);

      tablist.appendChild(tab);
      tabs.push(tab);
    });

    const mainPage = document.querySelector('.main-page');
    if (mainPage) {
      mainPage.appendChild(tablist);
    } else {
      sections[0].parentNode.insertBefore(tablist, sections[0]);
    }

    function activate(index, focusTab) {
      tabs.forEach((tab, i) => {
        const selected = i === index;
        tab.setAttribute('aria-selected', selected ? 'true' : 'false');
        tab.tabIndex = selected ? 0 : -1;
        wrappers[i].hidden = !selected;
      });
      if (focusTab) tabs[index].focus();
    }

    function onKeydown(e) {
      const current = tabs.findIndex((t) => t === e.currentTarget);
      let next;
      if (e.key === 'ArrowRight') next = (current + 1) % tabs.length;
      else if (e.key === 'ArrowLeft') next = (current - 1 + tabs.length) % tabs.length;
      else if (e.key === 'Home') next = 0;
      else if (e.key === 'End') next = tabs.length - 1;
      else return;
      e.preventDefault();
      activate(next, true);
    }
  }

  // Single-open accordions per Q&A section.
  handleAccordionClick(e) {
    const summary = e.target.closest && e.target.closest('summary');
    if (!summary) return;

    const details = summary.closest('details');
    const scope = summary.closest('.questions-and-answers');
    if (!details || !scope || details.open) return;

    scope.querySelectorAll('.accordion details[open]').forEach((other) => {
      if (other === details) return;
      const otherSummary = other.querySelector('summary');
      if (otherSummary) otherSummary.click();
    });
  }
}

customElements.define('qa-tabs', QaTabs);
